export const Version = {
	version: '1.46.0-dev.7.241',
};
